<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户合同'}, {label: '合同详情'}]"/>
    <contract-detail-component :contractDetail="contractDetail" />
    <button-back/>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import ContractDetailComponent from '../../components/ContractDetailComponent'
  import ButtonBack from "../../../components/ButtonBack";


  export default {
    name: "ContractDetail",
    data() {
      return {
        filterOption: {
          'ct.contractId' : this.$route.query['ct.contractId']
        },
        contractDetail: {}
      }
    },
    components: {
      ButtonBack,
      ContractDetailComponent
    },
    mounted() {
      this.getCustomerContractDetail()
    },
    methods: {
      getCustomerContractDetail: function () {
        xhr.getCustomerContractDetail(Object.assign(this.filterOption,{}), res=>{
          try{
            if(res.data.status == 'success') {
              this.contractDetail = res.data.data
            }
          }catch(e){}
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/ContractDetail.vue